import React from "react";
import type { SVGIconProps } from './BaseCardTypes';

const SVGIcon: React.FC<SVGIconProps> = ({
  className,
  viewBox,
  fillColor,
  path,
}) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={path} fill={fillColor} />
    </svg>
  );
};

export default SVGIcon;